export default __webpack_public_path__ + "static/media/ic_arrowleft.13502322.svg";